import type { Module } from 'vuex';
import type { RootState } from '@/vuex-store/RootState.interface';
import state from './state';
import mutations from './mutations';
import type { BettingState } from './BettingState.interface';

const bettingModule: Module<BettingState, RootState> = {
  namespaced: true,
  state,
  mutations,
};

export default bettingModule;
